import { z } from 'zod'

export type InformationForUseClauseFormData = {
  number: string
  title: string
  content: string
  fullStatement: string
}

export const informationForUseClauseFormSchema = z.object({
  number: z.string().trim().min(1),
  title: z.string().trim().min(1),
  content: z.string().trim().min(1),
  fullStatement: z.string().trim().min(1),
})

export function validateInformationForUseClauseForm(
  data: InformationForUseClauseFormData
) {
  return informationForUseClauseFormSchema.safeParse(data)
}
